import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.sass']
})
export class ProductosComponent implements OnInit {

  @Input() productos
  // @Input() idServicio
  constructor() { }

  ngOnInit(): void {
  }

}
